module.exports = __webpack_public_path__ + "files/d7670753ea5b5e336cd3aeaccc8827dc.png";